import React from "react";
import BICCWebsite from "./pages/bicc";

import "./index.css";

export default function App() {
  return <BICCWebsite />; // BICCWebsite can use NavLink/useLocation safely now
}
